import { jsx as _jsx } from "react/jsx-runtime";
import Spinner from 'react-bootstrap/Spinner';
import { BaseButton } from './BaseButton';
export const SpinnerButton = props => {
    let contentElements = [];
    const spinner = _jsx(Spinner, { as: 'span', animation: "border", size: "sm", role: "status", className: "mx-3" });
    const label = _jsx("span", Object.assign({ className: "btn-inner--text" }, { children: props.children }));
    if (props.spin && props.spinnerTextCombo) {
        contentElements.push(spinner);
        contentElements.push(label);
        if (props.spinnerTextComboFlipped)
            contentElements.reverse();
    }
    else if (props.spin) {
        contentElements.push(spinner);
    }
    else {
        contentElements.push(label);
    }
    return (_jsx(BaseButton, Object.assign({ disabled: props.spin }, props, { children: contentElements })));
};
